"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptDictionary = void 0;
const enums_1 = require("../../../../global/enums");
const ExtraLabels_1 = require("./ExtraLabels");
const TransactionTypes_1 = require("./TransactionTypes");
const WorldpayLabels_1 = require("./WorldpayLabels");
exports.ReceiptDictionary = {
    [enums_1.Language.ENGLISH]: {
        TransactionTypes: TransactionTypes_1.TransactionTypes[enums_1.Language.ENGLISH],
        WorldpayLabels: WorldpayLabels_1.WorldpayLabels[enums_1.Language.ENGLISH],
        ExtraLabels: ExtraLabels_1.ExtraLabels[enums_1.Language.ENGLISH],
    },
    [enums_1.Language.FRENCH]: {
        TransactionTypes: TransactionTypes_1.TransactionTypes[enums_1.Language.FRENCH],
        WorldpayLabels: WorldpayLabels_1.WorldpayLabels[enums_1.Language.FRENCH],
        ExtraLabels: ExtraLabels_1.ExtraLabels[enums_1.Language.FRENCH],
    },
};
//# sourceMappingURL=ReceiptDictionary.js.map